/**
 * @generated SignedSource<<35afae033bb9545424f266ebd4028ebd>>
 * @relayHash ec1e8ec0d8d42ddc6c3f415eac1c4624
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2d5aa37e2f5566ceeb8ca9eebbda2404294aceaca347f1143179d66719f49961

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GraphIntegrationDirectoryItemType = "ACTION" | "CUSTOM_SKILL" | "FORGE_SKILL" | "FORGE_TOOL" | "MCP_SERVER" | "MCP_TOOL" | "PLATFORM_SKILL" | "SKILL" | "%future added value";
export type AgentStudioSkillsQuery$variables = {
  cloudId: string;
  contextAri: string;
  isForgeSkillsEnabled: boolean;
  isStudioCustomSkillsM1FrontendEnabled: boolean;
  relevantFor?: ReadonlyArray<GraphIntegrationDirectoryItemType> | null;
};
export type AgentStudioSkillsQuery$data = {
  readonly connectedAppsQuery?: {
    readonly " $fragmentSpreads": FragmentRefs<"SkillsFilter_connectedAppsQuery">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SkillsFilter_productsQuery" | "SkillsList_AtlassianAgentStudioSkills_fragmentRef">;
};
export type AgentStudioSkillsQuery = {
  response: AgentStudioSkillsQuery$data;
  variables: AgentStudioSkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contextAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isForgeSkillsEnabled"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isStudioCustomSkillsM1FrontendEnabled"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "relevantFor"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "Variable",
  "name": "relevantFor",
  "variableName": "relevantFor"
},
v3 = {
  "kind": "Variable",
  "name": "contextAri",
  "variableName": "contextAri"
},
v4 = [
  (v3/*: any*/)
],
v5 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "surface",
    "value": "ROVO_AGENTS"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v10 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v11 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v12 = [
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AgentStudioSkillsQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Variable",
            "name": "isStudioCustomSkillsM1FrontendEnabled",
            "variableName": "isStudioCustomSkillsM1FrontendEnabled"
          },
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SkillsList_AtlassianAgentStudioSkills_fragmentRef"
      },
      {
        "args": (v4/*: any*/),
        "kind": "FragmentSpread",
        "name": "SkillsFilter_productsQuery"
      },
      {
        "condition": "isForgeSkillsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": (v4/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "SkillsFilter_connectedAppsQuery"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "connectedAppsQuery"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentStudioSkillsQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphIntegrationDirectoryItemEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isGraphIntegrationDirectoryItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "concreteType": "GraphIntegrationSkillUiMetadata",
                        "kind": "LinkedField",
                        "name": "uiMetadata",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "color"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "iconKey"
                          }
                        ]
                      },
                      {
                        "concreteType": "GraphIntegrationSkillMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          {
                            "condition": "isStudioCustomSkillsM1FrontendEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v11/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                  },
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "tags"
                          },
                          {
                            "concreteType": "GraphIntegrationSkillTool",
                            "kind": "LinkedField",
                            "name": "tools",
                            "plural": true,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "source"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "alias": "skillDescription",
                        "kind": "ScalarField",
                        "name": "description"
                      }
                    ],
                    "type": "GraphIntegrationSkillItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v12/*: any*/),
                    "type": "GraphIntegrationActionDirectoryItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v12/*: any*/),
                    "type": "GraphIntegrationMcpServer"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v12/*: any*/),
                    "type": "GraphIntegrationMcpTool"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v12/*: any*/),
                    "type": "GraphIntegrationSkillDirectoryItem"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v5/*: any*/),
        "filters": [
          "cloudId",
          "relevantFor",
          "surface",
          "searchKeyword",
          "dimensionIds"
        ],
        "handle": "connection",
        "key": "SkillsList_AtlassianAgentStudioSkills_graphIntegration_componentDirectoryItems",
        "kind": "LinkedHandle",
        "name": "graphIntegration_componentDirectoryItems"
      },
      {
        "condition": "isStudioCustomSkillsM1FrontendEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "AuthenticationContext",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v11/*: any*/),
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "products",
        "args": [
          (v3/*: any*/),
          {
            "kind": "Literal",
            "name": "dimension",
            "value": "PRODUCTS"
          }
        ],
        "concreteType": "GraphIntegrationSkillDimensionMetadata",
        "kind": "LinkedField",
        "name": "graphIntegration_skillDimensionMetadata",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v9/*: any*/),
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v10/*: any*/)
                ],
                "type": "GraphIntegrationSkillProductItem"
              }
            ]
          }
        ]
      },
      {
        "condition": "isForgeSkillsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "forgeApps",
            "args": [
              (v3/*: any*/),
              {
                "kind": "Literal",
                "name": "dimension",
                "value": "FORGE_APPS"
              }
            ],
            "concreteType": "GraphIntegrationSkillDimensionMetadata",
            "kind": "LinkedField",
            "name": "graphIntegration_skillDimensionMetadata",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2d5aa37e2f5566ceeb8ca9eebbda2404294aceaca347f1143179d66719f49961",
    "metadata": {},
    "name": "AgentStudioSkillsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6332df35d0d206bbe8c2c4894e16bd7e";

export default node;
